import axios from 'axios'

export default class {
	constructor() {
		this.api = axios.create({
			baseURL: '/',
			timeout: 60000,
		})
	}

	get(url, query) {
		return this.api.get(url, { params: query })
			.then(res => {
				if (res)
					return res['data'] ? res.data : {}
			})
	}

	delete(url, query) {
		return this.api.delete(url, { params: query })
			.then(res => {
				if (res)
					return res['data'] ? res.data : {}
			})
	}

	post(url, data) {
		return this.api.post(url, config, data)
			.then(res => {
				if (res)
					return res['data'] ? res.data : {}
			})
	}

	put(url, data) {
		return this.api.put(url, data)
			.then(res => {
				if (res)
					return res['data'] ? res.data : {}
			})
	}
}